import React from 'react';
import "./navBar.css";
import Logo from "../../icons/Full_Logo.png";

export const NavBar = ({route}) => {
  const url = "https://portal.notifier-global.com/login";

  const ChangeRoute = (route, title) => {
    window.open(route, "_self")
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If not on home page, navigate to home first
      window.open("/#" + sectionId, "_self");
    }
  }

  return (
    <div className='navBar'>
      <img 
        src={Logo} 
        className="logo" 
        alt="notifier" 
        width="150" 
        height="40"
        onClick={()=>ChangeRoute("/", "Notifier")}
      />
      <div className='links'>
        <h3 
          className='link'
          onClick={()=>ChangeRoute("/", "Notifier")}
          style={{fontWeight: route === "/" ? "bold" : "lighter"}}
        >Home</h3>
        <h3 
          className='link'
          onClick={()=>scrollToSection("mission")}
        >Mission</h3>
        <h3 
          className='link'
          onClick={()=>scrollToSection("offer")}
        >What We Offer</h3>
        <h3 
          className='link'
          onClick={()=>scrollToSection("pricing")}
        >Pricing</h3>
        <h3 
          className='link'
          onClick={()=>ChangeRoute("/privacy", "Notifier")}
          style={{fontWeight: route === "/privacy" ? "bold" : "lighter"}}
        >Privacy Policy</h3>
        <h3 
          className='link'
          onClick={()=>window.open(url)}
          style={{fontWeight: "bold"}}
        >Log In</h3>
      </div>
    </div>
  )
}
